'use strict';

var eventCategories = {
    AUTHENTICATION: 'AUTHENTICATION'
};

module.exports = eventCategories;